import { useEffect, useState } from 'react';
import { Page, Card, Typography } from 'seagull';
import { CopyToClipboard } from "../../components/CopyToClipboard/CopyToClipboard";
import ExternalLinkButton from "../../components/ExternalLinkButton";
import { useEventReporter } from "../../event-reporter";
import { useSetDocumentTitle } from "../../hooks/useSetDocumentTitle";
import { sendErrReport } from "../../infra/utils";
import { useStoreActions } from "../../store/store-context";
import { helpArticles } from "../../utils/helpArticles";
import styles from "./ReferralDashboard.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ReferralDashboard() {
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    sendEventToGtm
  } = useEventReporter();
  const [referral, setReferral] = useState();
  const [loading, setLoading] = useState(true);
  useSetDocumentTitle('Referrals');
  useEffect(() => {
    api.user.referral().then(referralData => {
      setReferral(referralData);
      setLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(Page, {
    header: "Referral Dashboard",
    subheader: "When a contact joins Anchor with your link and gets paid, you get credits. Nice!",
    skin: "secondary",
    "data-testid": "referral-dashboard",
    loading: loading,
    children: /*#__PURE__*/_jsxs(Card, {
      title: "Spread Anchor, Get Rewarded.",
      autoHeight: true,
      padding: "m",
      className: styles.card,
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(Typography, {
          children: ["Share your unique link with peers via email or social media and introduce them to Anchor! When they sign up, they'll receive a $50 Anchor credit as a welcome gift. Once they get their first payment, you'll also be rewarded with a $50 Anchor credit. Everyone wins!", ' ', /*#__PURE__*/_jsx(ExternalLinkButton, {
            openInNewTab: true,
            href: helpArticles.referralProgram(),
            children: "Read more"
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.innerCard,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "paragraph1",
          weight: "bold",
          children: "Share your unique referral link"
        }), /*#__PURE__*/_jsx(CopyToClipboard, {
          value: referral === null || referral === void 0 ? void 0 : referral.referralLink(),
          "data-testid": "referral-link",
          onError: () => sendErrReport('Failed to copy referral link'),
          onCopy: () => {
            logBI(18150);
            sendEventToGtm('refer_a_friend_copy_link', {});
          },
          disabled: loading
        }), /*#__PURE__*/_jsx(Typography, {
          "data-testid": "credits-earned",
          children: "Credits earned so far: ".concat(referral ? referral.creditsEarnedFormatted() : '$0')
        })]
      })]
    })
  });
}